var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4H28.0001V14.6667H24.0001L18.6667 17.3333V14.6667H14.6667V4Z",
    stroke: "#DD4937",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 21.3333V26.6667C20.0001 27.0203 19.8596 27.3594 19.6096 27.6095C19.3595 27.8595 19.0204 28 18.6667 28H8.00008C7.64646 28 7.30732 27.8595 7.05727 27.6095C6.80722 27.3594 6.66675 27.0203 6.66675 26.6667V7.99999C6.66675 7.64637 6.80722 7.30723 7.05727 7.05718C7.30732 6.80713 7.64646 6.66666 8.00008 6.66666H10.6667",
    stroke: "#DD4937",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 24V24.0133",
    stroke: "#DD4937",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSms);
export default __webpack_public_path__ + "static/media/phoneSMS.5cfdfd87542dfb986c71b776fb4ab76f.svg";
export { ForwardRef as ReactComponent };